var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoItemSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7006 31.6998C31.3014 32.1001 30.654 32.1001 30.2538 31.6998L24.5696 26.0158C25.0819 25.5646 25.5642 25.0813 26.0164 24.5691L31.7006 30.2531C32.0998 30.6523 32.0998 31.2996 31.7006 31.6998ZM14.0078 28.0159C6.27148 28.0159 0 21.7425 0 14.0084C0 6.27133 6.27148 0 14.0078 0C21.7441 0 28.0155 6.27133 28.0155 14.0084C28.0155 21.7436 21.7431 28.0159 14.0078 28.0159ZM14.0078 2.00106C7.37709 2.00106 2.00111 7.37792 2.00111 14.0084C2.00111 20.638 7.37609 26.0138 14.0078 26.0138C20.6394 26.0138 26.0144 20.638 26.0144 14.0084C26.0144 7.37792 20.6384 2.00106 14.0078 2.00106Z",
    fill: "#545E77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItemSearch);
export default __webpack_public_path__ + "static/media/no-item-search.2f35d1a7880421e579d8d4cd35d9a448.svg";
export { ForwardRef as ReactComponent };